// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"684":"9ef80bb6","787":"e4fe5093"}[chunkId] + ".chunk.js";
};